module.exports = __webpack_public_path__ + "img/default_img_5.0e11e200.png";